<template>
    <div :id="this.id" @contextmenu.prevent="handler($event)"
         class="sitebuilder-element-container"
         element="SimpleFormComponent"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
         :style="style()" v-on:click="focusElement($event)">


        <form @submit.prevent="submit($event, internal_config)"
              :class="horizontal ? 'form-mboss horizontal-form': 'form-mboss'" ref="form"
              method="post" :action="internal_config.action"
              :receiver="internal_config.receiver" :subject="internal_config.subject">
            <div class="inputs-area" ref="container"></div>
            <div class="place-btn">
                <div class="bt-sb"
                     v-bind:style="{
                        width : buttonWidth,
                        border : buttonBorder,
                        'border-radius': buttonRadius,
                        background: buttonBackground,
                        'box-shadow': buttonBoxShadow
                        }">
                    <div class="bt-text-area">
                        <button v-on:click="submit($event, internal_config)" class="btn sb-text"
                                :style="textStyle()">{{internal_config.button.text}}
                        </button>
                        <br :v-show="this.internal_config.button.subtext != ''"/>
                        <small class="btn sb-sub-text" v-show="this.internal_config.button.subtext != ''"
                               :style="subTextStyle()">{{internal_config.button.subtext}}</small>
                    </div>
                </div>
            </div>
        </form>


    </div>
</template>

<script>

	import Vue from 'vue';
	import axios from 'axios';
	import Data from './Model';
	import Resources from './Resources.vue';
	import {SweetModal} from 'sweet-modal-vue'

	import CheckFields from "../Fields/CheckFields.vue";
	import SelectFields from "../Fields/SelectFields.vue";
	import TextFields from "../Fields/Text.vue";
	import DateFields from "../Fields/DateFields.vue";

	export default {
		name: 'SimpleFormComponent',
		props: ['config', 'id', 'preview'],
		components: {
			Data,
			Resources,
			SweetModal,
			CheckFields,
			SelectFields,
			TextFields,
			DateFields
		},
		computed: {
			horizontal() {
				return this.internal_config.horizontal;
			},
			buttonWidth() {
				return parseInt(this.internal_config.button.width) + '%';
			},
			buttonBorder() {
				return this.internal_config.button.border;
			},
			buttonBoxShadow() {
				return this.internal_config.button.boxShadow;
			},
			buttonRadius() {
				return this.internal_config.button.borderRadius;
			},
			buttonBackground() {
				let bg = this.internal_config.button.backgroundColor;

				if (this.internal_config.backgroundImage !== 'none') {
					bg += ' url("' + this.internal_config.button.backgroundImage + '")';
					bg += ' ' + this.internal_config.button.backgroundPosition;
					bg += ' / ' + this.internal_config.button.backgroundSize;
					bg += ' ' + this.internal_config.button.backgroundRepeat;
					bg += ' ' + this.internal_config.button.backgroundOrigin;
				}

				return bg;
			}
		},
		data() {
			return Data.data();
		},
		methods: {

			submit(e, config) {

				e.preventDefault();

				console.log(config);
				var kvpairs = [];
				let form = document.getElementById(this.id).querySelectorAll('form')[0];

				let valid = true;
				let message = [];


				for (var i = 0; i < form.elements.length; i++) {
					var e = form.elements[i];

					config.fields.forEach(field => {
						if (field.tag === e.name && field.required === 'yes' && e.value === '') {
							console.log(e.value)
							valid = false;
							message.push(field.label + " is required.")
						}
					})
					kvpairs.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value));

				}

				var queryString = kvpairs.join("&");


				if (valid) {

					if (config.action !== '') {
						this.$refs.form.submit();
					} else {

						if (config.receiver === '' || config.receiver === null) {
							valid = false;
							e.preventDefault();
							message.push("receiver not configured");
						}


						if (config.subject === '' || config.subject === null) {
							valid = false;
							e.preventDefault();
							message.push("subject not configured");
						}

						queryString = queryString + '&receiver=' + config.receiver + '&subject=' + config.subject;
						axios.post('/cheetah/form_submit', queryString)
							.then(res => {
								// this.$refs.success_send.open();
								this.$root.$emit('successMessagePopup');
							})
					}


				} else {
					// this.errorMessage = message;
					// this.$refs.required_fields.open()
                    this.$root.$emit('errorMessagePopup',message);
				}


				// console.log('send this data to this email with this subject');

				// console.log(this.internal_config.receiver);
				// console.log(this.internal_config.subject);

				// this.$refs.form.submit()
			},
			save() {
				this.buildFields(this)
				this.$refs.modal.close();
			},
			buildFields: function (vm) {

				this.$refs.container.innerHTML = '';

				vm.internal_config.fields.forEach(field => {
					console.log(field);
					let identifier = field.field;
					if (typeof identifier === 'undefined') {
						identifier = 'text';
					}


					if (identifier === 'textarea') vm.createTextField(field, true);
					if (identifier === 'text') vm.createTextField(field, false);
					if (identifier === 'multiselect') vm.createDropDown(field, true);
					if (identifier === 'dropdown') vm.createDropDown(field, false);
					if (identifier === 'datetime') vm.createDateTime(field, true);
					if (identifier === 'date') vm.createDateTime(field, false);
					if (identifier === 'checkbox') vm.createCheckField(field, 'checkbox');
					if (identifier === 'radio') vm.createCheckField(field, 'radio');
				});
				$('body').removeClass('loading');
			},
			onResize: function (x, y, width, height) {
				this.internal_config.width = width + 'px';
				this.internal_config.height = height + 'px';

			}
			,
			toggle: function () {
				this.$root.$emit('toggleElement', this);
			}
			,
			deleteElement() {
				// console.log(this.id);
				this.$root.$emit('deleteElement', this)
			}
			,
			duplicateElement() {
				this.$root.$emit('duplicateElement', this, this.internal_config);
			}
			,
			focusElement(e) {
				this.$root.$emit('focusElement', this);
				e.stopPropagation();
				e.preventDefault();
			}
			,
			showResources() {
				return this.$refs.resourcesData.getValuesData();
			}
			,
			callReorder(idx) {
				if (typeof this.$parent.changeOrderPanel !== 'undefined') {
					this.$parent.changeOrderPanel(this, idx);
				} else {
					this.$parent.$parent.changeOrderPanel(this, idx);
				}
			}
			,
			edit(e) {
				e.preventDefault();
				this.internal_config.src = prompt('src', this.internal_config.src);
			}
			,

			textStyle() {
				return `font-family:  ${this.internal_config.button.textStyle.family};
                 font-size: ${this.internal_config.button.textStyle.size};
                 text-align: ${this.internal_config.button.textStyle.align};
                 font-weight: ${this.internal_config.button.textStyle.weight};
                 font-style: ${this.internal_config.button.textStyle.style};
                 color: ${this.internal_config.button.textStyle.color}`;
			},

			subTextStyle() {
				return `font-family:  ${this.internal_config.button.subTextStyle.family};
                 font-size: ${this.internal_config.button.subTextStyle.size};
                 text-align: ${this.internal_config.button.subTextStyle.align};
                 font-weight: ${this.internal_config.button.subTextStyle.weight};
                 font-style: ${this.internal_config.button.subTextStyle.style};
                 color: ${this.internal_config.button.subTextStyle.color}`;
			}
			,
			buildIcon: function () {

				$(this.$el).find('i').detach();

				if (this.internal_config.button.icon !== '') {
					if (this.internal_config.button.iconPosition === 'left') {
						$('<i>').addClass('mdi ' + this.internal_config.button.icon).prependTo($(this.$el).find('.sb-text').get(0));
					}
					if (this.internal_config.button.iconPosition === 'right') {
						$('<i>').addClass('mdi ' + this.internal_config.button.icon).appendTo($(this.$el).find('.sb-text').get(0));
					}
				}
			}
			,
			build(config) {
				this.internal_config = config;

				this.buildIcon();
			}
			,
			style() {
				return `left:  ${this.internal_config.left};
				        padding-top: ${this.internal_config.paddingTop};
                     z-index: ${this.internal_config.zIndex};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                width: ${this.internal_config.width};
                top: ${this.internal_config.top}`;
			}
			,
			styleResize() {
				return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
			}
			,
			handler: function (e) {
				this.$root.$emit('focusElement', this);
				this.$root.$emit('handlerElement', this);
				e.stopPropagation();
				e.preventDefault();
			},
			createCheckField(field, type) {
				let ComponentClass = Vue.extend(CheckFields);
				let instance = new ComponentClass({
					propsData: {
						type: type,
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						label: field.label,
						options: field.options,
						selected: [],
						data: field,
					}
				});
				instance.$mount();
				this.$refs.container.appendChild(instance.$el)
			},
			createDropDown(field, multiple) {
				let ComponentClass = Vue.extend(SelectFields);
				let instance = new ComponentClass({
					propsData: {
						label: field.label,
						options: field.options,
						selected: [],
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						data: field,
						multiple: multiple,
					}
				});
				instance.$mount();
				this.$refs.container.appendChild(instance.$el)
			},
			createDateTime(field, useCurrent) {

				let ComponentClass = Vue.extend(DateFields);
				let instance = new ComponentClass({
					propsData: {
						label: field.label,
						data: field,
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						value: new Date().toString(),
						type: (useCurrent ? 'datetime' : 'date'),
					}
				});
				instance.$mount();
				this.$refs.container.appendChild(instance.$el)
			},
			createTextField(field, area) {


				let ComponentClass = Vue.extend(TextFields);
				let instance = new ComponentClass({
					propsData: {
						label: field.label,
						value: '',
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						data: field,
						area: area,
					}
				});
				instance.$mount();
				console.log(area);
				console.log(instance.$el);


				this.$refs.container.appendChild(instance.$el)
			},
			inputStyle() {

				let vm = this;

				let elements = this.$refs.container.getElementsByClassName('form-control');
				[].forEach.call(elements, function (el) {
					el.style.backgroundColor = vm.internal_config.inputColor;
					el.style.border = vm.internal_config.inputBorder;
					el.style.height = vm.internal_config.inputHeight;
					el.style.borderRadius = vm.internal_config.inputRadius;

					el.style.fontFamily = vm.internal_config.inputStyle.family;
					el.style.fontSize = vm.internal_config.inputStyle.size;
					el.style.textAlign = vm.internal_config.inputStyle.align;
					el.style.fontStyle = vm.internal_config.inputStyle.style;
					el.style.fontStyle = vm.internal_config.inputStyle.style;
					el.style.color = vm.internal_config.inputStyle.color;
				});
			},
		},

		mounted() {

			let vm = this;

			this.build(this.$props.config);

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

			if (this.$props.preview) {
				this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
				this.$el.classList.add('preview');

				this.$el.addEventListener('mouseover', function () {
					document.body.style.setProperty('--button-background-color--hover', vm.internal_config.button.backgroundColorHover);
				});
			}


			this.buildFields(this);

			this.inputStyle();
		},
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .sitebuilder-element-container .vdr,
    .vdr, .bt-sb,
    form.form-simple {
        height: auto !important;
    }

    .place-btn {
        text-align: center;

        .bt-sb {
            display: inline-block;
        }
    }

    .bt-text-area {
        display: block;
    }

    [data-device="mobile"] .bt-text-area {
        width: auto !important;
    }

    .horizontal-form {
        display: flex;

        .inputs-area {
            width: 50%;
        }

        .place-btn {
            width: 50%;
            position: relative;

            .bt-sb {
                position: absolute;
                bottom: 15px;
                left: 0;
            }
        }
    }
</style>
<style lang="scss">

    select.form-control[multiple], select.form-control[size],
    textarea.form-control {
        height: auto !important;
    }

    .list-item {
        display: block;
        width: 100%;
        border: 1px solid lightgrey;
        border-radius: 5px;
        margin-top: 2px;
        cursor: pointer;
    }

    .list-item.selected {
        border: 1px solid blue;
    }
</style>
